import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedArticles() {
  const featured = articles.filter((a) => a.featured);

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
      <div className="text-center mb-10">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
          精选文章
        </h2>
        <p className="mt-2 text-sm md:text-base text-foreground-500">
          由专家团队精心编写的育儿知识，助你轻松应对育儿挑战
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {featured.slice(0, 6).map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
          >
            <div className="relative h-48 overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute top-3 left-3">
                <span className="px-2.5 py-1 bg-primary-500 text-white text-xs rounded-full font-medium whitespace-nowrap">
                  {article.categoryName}
                </span>
              </div>
            </div>
            <div className="p-4 md:p-5 flex flex-col flex-1">
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                {article.title}
              </h3>
              <p className="text-sm text-foreground-500 line-clamp-2 mb-3 flex-1">
                {article.excerpt}
              </p>
              <div className="flex items-center justify-between text-xs text-foreground-400 pt-3 border-t border-background-200/70">
                <span className="flex items-center gap-1">
                  <i className="ri-user-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  {article.author}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  {article.readTime} 分钟阅读
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="text-center mt-10">
        <Link
          to="/category/newborn-care"
          className="inline-flex items-center gap-2 px-6 py-2.5 bg-secondary-100 text-secondary-700 rounded-full text-sm font-medium hover:bg-secondary-200 transition-colors cursor-pointer whitespace-nowrap"
        >
          查看全部文章
          <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
        </Link>
      </div>
    </section>
  );
}